import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  Music2,
  Baby,
  Flame,
  Sparkles,
  HandHeart,
  Heart,
  Shield,
  Video,
  ArrowUpRight,
} from "lucide-react";
import { MINISTRIES } from "@/lib/data";

const ICONS = { Music2, Baby, Flame, Sparkles, HandHeart, Heart, Shield, Video };

export default function Ministries() {
  return (
    <section
      id="ministerios"
      data-testid="ministries-section"
      className="bg-[#050505] py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="text-xs tracking-overline uppercase text-[#D4AF37] mb-6"
            >
              Nossos Ministérios
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              data-testid="ministries-title"
              className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.05] tracking-tight max-w-3xl"
            >
              Cada dom, <span className="italic text-white/80">cada chamado,</span>{" "}
              <span className="text-[#D4AF37]">a serviço</span> do Reino.
            </motion.h2>
          </div>
          <p className="text-white/60 max-w-sm text-base leading-relaxed">
            Oito frentes ativas para servir, ensinar e amar — um lugar para você
            usar seus dons. Clique em qualquer ministério para conhecer a
            história e a equipe.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5">
          {MINISTRIES.map((m, idx) => {
            const Icon = ICONS[m.icon] || Sparkles;
            return (
              <motion.div
                key={m.slug}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: (idx % 3) * 0.08 }}
              >
                <Link
                  to={`/ministerios/${m.slug}`}
                  data-testid={`ministry-card-${m.slug}`}
                  className="group relative bg-[#0A0A0A] p-8 sm:p-10 flex flex-col justify-between min-h-[280px] hover:bg-[#0F0F0F] transition-all duration-500 h-full"
                >
                  <div className="flex items-start justify-between">
                    <div className="w-12 h-12 border border-[#D4AF37]/30 flex items-center justify-center text-[#D4AF37] group-hover:bg-[#D4AF37] group-hover:text-black transition-all duration-500">
                      <Icon size={22} strokeWidth={1.5} />
                    </div>
                    <ArrowUpRight
                      size={18}
                      strokeWidth={1.5}
                      className="text-white/30 group-hover:text-[#D4AF37] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-500"
                    />
                  </div>

                  <div className="mt-12">
                    <h3 className="font-serif-display text-3xl text-white">
                      {m.title}
                    </h3>
                    <p className="mt-4 text-sm leading-relaxed text-white/65 max-w-xs">
                      {m.description}
                    </p>
                    <span className="mt-6 inline-flex items-center gap-2 text-[10px] tracking-overline uppercase text-[#D4AF37] opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                      Conhecer ministério
                      <ArrowUpRight size={12} strokeWidth={1.5} />
                    </span>
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
